import React, { useEffect, useState } from "react";
import { CommentModal } from "./Tracker/CommentModal";
import CommentIcon from "@mui/icons-material/Comment";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";
import { LockableIconButton } from "./LockableIconButton";
import { DetailedEvent } from "../requests/matchEvents";
import { useCommentsQuery } from "../requests/v2/comments";

type CommentInputProps = {
  event: DetailedEvent;
  // On click, pause the video to prevent the video from playing while editing tags.
  pauseVideo: () => void;
  disabled?: boolean;
};

export const CommentInput = ({ event, pauseVideo, disabled = false }: CommentInputProps) => {
  const [commentEvent, setCommentEvent] = useState<DetailedEvent | null>(null);

  // Prefetch
  useCommentsQuery(event.id, event.is_comment);

  // It probably shouldn't be necessary to pause in a useEffect, but I'm not going to debug this right now.
  useEffect(() => {
    if (commentEvent) {
      pauseVideo();
    }
  }, [commentEvent, pauseVideo]);

  return (
    <>
      <CommentModal
        event={commentEvent}
        setEventNull={() => {
          setCommentEvent(null);
        }}
      />
      <LockableIconButton
        lockMessage="Cannot edit comment while another event is selected."
        isLocked={disabled}
        onClick={(e) => {
          pauseVideo();
          setCommentEvent(event);
          e.stopPropagation();
        }}
      >
        <span>
          {event.is_comment ? (
            <CommentIcon color="primary" sx={disabled ? { opacity: "66%" } : {}} />
          ) : (
            <AddCommentOutlinedIcon />
          )}
        </span>
      </LockableIconButton>
    </>
  );
};
